var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAltlestoneProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1929",
    d: "M0-682.665H47v47H0Z",
    transform: "translate(0 682.665)",
    stroke: "#0a64f9",
    strokeWidth: 3.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989",
    transform: "translate(-908 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 401)",
    fill: "#e8f1ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1923",
    transform: "translate(936.5 1114.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1925",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1927",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1933",
    transform: "translate(1.836 1.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1935",
    d: "M-586-243.34v-8.812a9.18,9.18,0,0,0-9.18-9.18h-24.969a9.18,9.18,0,0,0-9.18,9.18v24.969a9.18,9.18,0,0,0,9.18,9.18h9.18",
    transform: "translate(629.332 261.333)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1937",
    transform: "translate(18.818 10.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1939",
    d: "M0,0H9.363",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1945",
    transform: "translate(26.713 31.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1947",
    d: "M0-60.516l3.458,3.541a3.773,3.773,0,0,0,5.392,0l9.6-9.691",
    transform: "translate(0 66.667)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltlestoneProduct);
export default __webpack_public_path__ + "static/media/altlestoneProduct.b6b37125324843a65645d0f91c372108.svg";
export { ForwardRef as ReactComponent };